<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <button
      *ngIf="!is_sync_running"
      mat-button
      (click)="contract_upload.click()"
      class="sp-width__full sp-button__dashed-accent sp-bank-account__height">
      <mat-icon
        class="sp-color__accent"
        matPrefix>
        upload
      </mat-icon>
      <span> {{ 'STEPS.SYNC_CTA' | translate }} (.csv) </span>
    </button>

    <input
      type="file"
      accept="text/csv"
      class="sp-display__none"
      (change)="onSyncClick($event)"
      #contract_upload />

    <div
      *ngIf="is_sync_running"
      class="sp-column__center sp-width__full sp-padding__x2">
      <mat-spinner
        color="accent"
        diameter="40"></mat-spinner>
      <p class="sp-color__accent sp-text__center sp-margin__top">Loading...</p>
    </div>
  </div>
</div>
